import React, {useState, useEffect, useContext} from 'react';
import {styled, createTheme, ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import {Context as AuthContext} from '../../contexts/AuthContext';
import {Context as DashboardContext} from '../../contexts/DashboardContext';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import GeneralDashboard from './GeneralDashboard';
import FinancialDashboard from '../Dashboard/FinancialDashboard';
import AtRiskDashboard from '../Dashboard/AtRiskDashboard';
import {useIntercom} from 'react-use-intercom';
import HomeDrawer from '../../components/Common/HomeDrawer';

const DashboardHome = ({}) => {
  const {state: route} = useLocation();
  const {boot, shutdown, hide, show, update} = useIntercom();
  const [index, setIndex] = useState(route && route.index ? route.index : 0);
  const [loaded, setLoaded] = useState(false);

  const {
    state: {uid, universal},
  } = useContext(AuthContext);

  const {getProfiles, getAtRisk, getFakeData} = useContext(DashboardContext);

  const [orgCode, setOrgCode] = useState(
    universal && universal.organizationCode ? universal.organizationCode : null,
  );

  useEffect(() => {
    if (!orgCode || !universal.dashboard) {
      return;
    }

    if (universal.dashboard.role === 'owner' && orgCode === 'fake') {
      getFakeData();
    } else if (universal.dashboard.role === 'demo' && orgCode === 'fake') {
      getFakeData();
    } else {
      getProfiles(orgCode);
      getAtRisk(orgCode);
    }
  }, [orgCode]);

  // useEffect(() => {
  //   // boot();
  //   // window.intercomSettings = {
  //   //   api_base: 'https://api-iam.intercom.io',
  //   //   app_id: 'ww60whap',
  //   //   name: 'Charlie Caswell', // Full name
  //   //   email: 'chcaswell10@gmail.com', // Email address
  //   //   created_at: '1312182000', // Signup date as a Unix timestamp
  //   // };
  //   (function () {
  //     var w = window;
  //     var ic = w.Intercom;
  //     if (typeof ic === 'function') {
  //       ic('reattach_activator');
  //       ic('update', w.intercomSettings);
  //     } else {
  //       var d = document;
  //       var i = function () {
  //         i.c(arguments);
  //       };
  //       i.q = [];
  //       i.c = function (args) {
  //         i.q.push(args);
  //       };
  //       w.Intercom = i;
  //       var l = function () {
  //         var s = d.createElement('script');
  //         s.type = 'text/javascript';
  //         s.async = true;
  //         s.src = 'https://widget.intercom.io/widget/ww60whap';
  //         var x = d.getElementsByTagName('script')[0];
  //         x.parentNode.insertBefore(s, x);
  //       };
  //       if (document.readyState === 'complete') {
  //         l();
  //       } else if (w.attachEvent) {
  //         w.attachEvent('onload', l);
  //       } else {
  //         w.addEventListener('load', l, false);
  //       }
  //     }
  //   })();
  // }, []);

  return (
    <>
      <Box sx={{display: 'flex', minWidth: '1400px'}}>
        <CssBaseline />
        <HomeDrawer
          index={index}
          setIndex={setIndex}
          product="dashboard"
          orgCode={orgCode}
          setOrgCode={setOrgCode}
        />
        {index === 0 && <GeneralDashboard />}
        {index === 1 && <FinancialDashboard />}
        {index === 2 && <AtRiskDashboard />}
      </Box>
    </>
  );
};

export default DashboardHome;
